import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { NumberInput } from 'ui-components/components/number-input';

import { createColumnDefinitionBuilder } from '../../../../../../../components/items-table/create-column-definition-builder';

import { messages } from '../../messages';
import style from '../../style.module.css';

const EditProductQuantityColumnId = 'edit-quantity';
const QuantityPropertyName = 'quantity';

const editProductQuantityDataBuilder = (item) => {
  return {
    id: item.id,
    quantity: item.quantity,
    readonly: item.readonly,
  };
};

// TODO: Rather than setting a min value on the input, we should have validation that lets
// the merchant go to a non-positive integer, but inform them of the error on blur
const EditProductQuantity = ({ value: item, onColumnBlur, disabled = false }) => {
  const [quantity, setQuantity] = useState(item.quantity);

  const publishValueChange = useCallback(
    (value) => {
      onColumnBlur(item.id, {
        [QuantityPropertyName]: value,
      });
    },
    [onColumnBlur, item.id],
  );

  const onArrowButtonPress = useCallback(
    (value) => {
      publishValueChange(value);
      setQuantity(value);
    },
    [setQuantity, publishValueChange],
  );

  const onBlur = useCallback(
    (event) => {
      const parsedValue = Number.parseInt(event?.target?.value, 10);
      setQuantity(parsedValue);
      publishValueChange(parsedValue);
    },
    [setQuantity, publishValueChange],
  );

  return (
    <NumberInput
      className={style['quantity-input']}
      disabled={disabled}
      min={1}
      onArrowButtonPress={onArrowButtonPress}
      onBlur={onBlur}
      onChange={setQuantity}
      value={quantity}
    />
  );
};

EditProductQuantity.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    readonly: PropTypes.shape({
      code: PropTypes.string,
    }),
  }).isRequired,
  onColumnBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const createEditProductQuantityColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.productBundleComponentQuantity} />,
  accessor: EditProductQuantityColumnId,
  cell: EditProductQuantity,
  width: 0.5,
  className: style.column,
});

export { EditProductQuantityColumnId, editProductQuantityDataBuilder, createEditProductQuantityColumnDefinition };
